/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import * as talonOneRewardsActions from './TalonOneRewards-Actions';
import * as talonOneRewardsActionTypes from './TalonOneRewards-ActionTypes';
import * as talonOneRewardsSelectors from './TalonOneRewards-Selectors';
import talonOneRewardsOperations from './TalonOneRewards-Operations';
import reducer from './TalonOneRewards-Reducer';

const talonOneRewardsWatcherSagas = [
    ...talonOneRewardsOperations.watchers,
];

export {
    talonOneRewardsActions,
    talonOneRewardsActionTypes,
    talonOneRewardsSelectors,
    talonOneRewardsOperations,
    talonOneRewardsWatcherSagas,
};

export default reducer;
